import { clsx } from 'clsx'

import { ContentRenderer } from '../Components/ContentRenderer.js'
import { MediaRenderer } from '../Components/MediaRenderer.js'
import { type HeroBannerProps } from '../types.js'
import {
  getContentSpacingClass,
  getMediaAspectRatioClass,
} from '../utils/utils.js'

interface TopBottomLayoutProps extends HeroBannerProps {
  reverse?: boolean
}
export const TopBottomLayout = ({
  contentSpacing,
  mediaAspectRatio,
  eyebrow,
  heading,
  description,
  textColor,
  textAlignment,
  mediaType,
  image,
  video,
  mediaTint,
  backgroundColor,
  className,
  reverse,
  actionType,
  buttonActions,
  searchAction,
  ...rest
}: TopBottomLayoutProps) => {
  const spacingClass = getContentSpacingClass(contentSpacing)
  const mediaAspectRatioClass = getMediaAspectRatioClass(mediaAspectRatio)

  return (
    <div
      className="@container"
      data-block-id={rest['data-block-id']}
      data-block-name={rest['data-block-name']}
    >
      <div
        className={clsx(
          className,
          'flex rounded-base overflow-hidden',
          'rounded-screen-none',
          reverse ? 'flex-col' : 'flex-col-reverse',
        )}
        style={{ backgroundColor }}
      >
        <ContentRenderer
          actionType={actionType}
          buttonActions={buttonActions}
          searchAction={searchAction}
          textColor={textColor}
          textAlignment={textAlignment}
          eyebrow={eyebrow}
          heading={heading}
          description={description}
          className={clsx('px-6 @3xl:px-10 @5xl:px-16', spacingClass)}
        />
        <div className={clsx('relative', mediaAspectRatioClass)}>
          <MediaRenderer
            mediaType={mediaType}
            image={image}
            video={video}
            mediaTint={mediaTint}
            textColor={textColor}
          />
        </div>
      </div>
    </div>
  )
}
